import TabPanel from "../TabPanel";
import { SettingsModalTabProps } from "../types";
import HumanResourcesManagement from "./HumanResourcesManagement";

const HumanResourcesManagementTab: React.FC<SettingsModalTabProps> = ({ parentTab, index }) => {
  return (
    <TabPanel value={parentTab} index={index} paddingX={1} height={"calc(100vh - 110px)"}>
      <HumanResourcesManagement />
    </TabPanel>
  )
}
export default HumanResourcesManagementTab;
